import { toast as c } from "react-hot-toast";
import "node-object-hash/dist/objectSorter";
async function t(p, r, o = r("public_pages_purchase.copy_clipboard")) {
  try {
    if (!document.hasFocus())
      throw new Error();
    await navigator.clipboard.writeText(p), o && c.success(o);
  } catch {
    c.error(r("public_pages_purchase.copy_clipboard_error"));
  }
}
export {
  t as copyTextToClipboard
};
